<template>
  <v-card :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'">
    <IbCommissionInTabTable></IbCommissionInTabTable>
  </v-card>
</template>
<script>
import IbCommissionInTabTable from "./IbCommissionInTabTable.vue";

export default {
  components: {
    IbCommissionInTabTable,
  },
};
</script>
